module.exports = __webpack_public_path__ + "img/bannerMobile.9a2e345c.jpg";